// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3EsZx","actions":"GroupTable_actions__5hbHF","deleteModalFooter":"GroupTable_deleteModalFooter__2xNgL"};